import { AxiosInstance } from "axios";
import { ApiService } from "../models/Api.model";
import { IQuote } from "../interfaces/trade/precificacao/IQuote";
import { IPricingCalculatorResponse } from "../interfaces/calculator/IPricingCalculatorResponse";
import { IPricing } from "../interfaces/calculator/IPricing";
import { IUpdateQuotePricing } from "../interfaces/trade/precificacao/IUpdateQuotePricing";

enum QuotePricingServiceEnum {
  calculateMinMaxValue = "/calculate-min-max-values/",
  updatereducedPercentLender = "/update-reduce-percent-lender",
  savePricing='/'
}

export default class QuotePricingService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/quote/pricing");
  }

  public calculateMinMaxValue = async (id: number): Promise<IQuote> => await this.GET(QuotePricingServiceEnum.calculateMinMaxValue + id);
  public updateQuotePricingParameters = async (updateQuotePricing: IUpdateQuotePricing): Promise<IQuote> => await this.PUT(`${QuotePricingServiceEnum.updatereducedPercentLender}`, updateQuotePricing);

    public savePricing = async (pricingRequest: IPricingCalculatorResponse, idQuote: number): Promise<IPricing> => 
    await this.POST(`${QuotePricingServiceEnum.savePricing}${idQuote}`, pricingRequest);
}



// WEBPACK FOOTER //
// ./src/services/api/QuotePricing.service.ts